<template>
  <div class="vue-tempalte">
    <!-- <nav class="navbar shadow bg-white rounded justify-content-between flex-nowrap flex-row fixed-top"> -->
    <nav class="navbar shadow bg-white rounded justify-content-between flex-nowrap flex-row static-top">
      <div class="container">

        <div v-if="userLoggedIn == true">
            User: {{userName}}
            <br>
            <a href='#' v-on:click='logOut()'>Logout</a>
        </div>
        <div v-else>
            User not logged in.
            <br>
            <router-link to="/login">Sign in</router-link>
        </div>

        <div class="row">
          <div class="col-sm-12 text-center">
              <a v-if="isRefresh" href="#" @click="update()">Click here to update to New Version</a>
          </div>
        </div>

        <a href="/"><img src="/SLa_1_64x64.png" class="img-fluid" alt="Responsive image"></a>

      </div>
    </nav>

    <div class="App">
      <div class="vertical-center">
        <div class="inner-block">
            <router-view>
            </router-view>
        </div>
      </div>
    </div>
    
    <nav class="navbar shadow bg-white rounded justify-content-between flex-nowrap flex-row fixed-bottom">
      <div>
        <a href="https://www.signledger.com" target="_blank">SignLedger LLC</a>
        <span class="ml-1">&copy; {{new Date().getFullYear()}} </span>
      </div>

      <div class="text-right">
        {{ onlineStatus }}
      </div>
    </nav>

  </div> 
</template>

<script>
import { firebase } from '@firebase/app'
import 'firebase/auth'

  export default {
      name: "App",
  
      components: {
      },

      data() {
        return {
          userLoggedIn: false,
          userName: '',
          orgName: '',

          // check internet status
          onLine: navigator.onLine,
          showBackOnline: false,
          onlineStatus: 'OnLine',

          // Refresh PWA
          version: "1.03",
          registration:null,
          isRefresh: false,
          refreshing: false,

        }
      },

      beforeMount: function () {
      },

      mounted () {
        var self = this
        self.logIn()

        // 'logIn' : Triggered by - Login.vue
        this.bus.$on('logIn', () => {
          self.logIn()
        })

        // 'logOut' : Triggered by - Login.vue
        this.bus.$on('logOut', () => {
          self.logOut()
        })

        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);

      },

      beforeDestroy() {
          window.removeEventListener('online', this.updateOnlineStatus);
          window.removeEventListener('offline', this.updateOnlineStatus);
      },

      // Refresh PWA
      created() {
          console.log("Version: " + this.version)
          document.addEventListener(
              'serviceWorkerUpdateEvent', this.appUpdateUI, { once: true }
          )
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            // We'll also need to add 'refreshing' to our data originally set to false.
            if (this.refreshing) return
            this.refreshing = true
            // Here the actual reload of the page occurs
            window.location.reload()
          })

      },

      watch: {
          onLine(v) {
              if (v) {
                  this.showBackOnline = true;
                  setTimeout(() => {
                      this.showBackOnline = false;
                  }, 1000);
              }
          }
      },

      methods: {

        updateOnlineStatus(e) {
            const {
                type
            } = e;
            //this.onLine = type === 'online'
            if (type=='online'){
              this.onlineStatus = 'OnLine'
            }
            else {
              this.onlineStatus = 'OffLine'
            }

        },

        logIn () {
          var self = this

          firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
              self.userLoggedIn = true
              self.userName = user.email
            } else {
              self.userLoggedIn = false
              self.userName = ''
              // Clear User Profile from Session State
              self.saveUserProfile('')
            }
          })
        },

        logOut () {
          var self = this
          firebase.auth().signOut()
            .then(function () {
              // Clear Login Info in Header  
              self.logIn()
              // Show Home Page
              if (self.$route.name != 'Home') { self.$router.push('/') }
            })
            .catch(function (error) {
              alert('Signout unsuccessful: ' + error)
            })
        },

        // ***** Refresh PWA
        appUpdateUI:function (e){
          this.registration = e.detail;
          this.isRefresh = true;
        },

        update(){
          this.isRefresh = false;
          if (this.registration || this.registration.waiting) {
            this.registration.waiting.postMessage({type:'SKIP_WAITING'});
          }
        },
        // ***** Refresh PWA


      }
  }

</script>